import update from "immutability-helper";

import {
  //Загрузка информации о шаблоне визитки
  TEMPLATE_INFO_LOADING_START,
  TEMPLATE_INFO_LOADED_SUCCESSFULLY,
  TEMPLATE_INFO_LOADING_FAILED,
  //Изменение видимости шаблона визитки
  TEMPLATE_VISIBILITY_CHANGED_SUCCESSFULLY,
  //Удаление шаблона
  TEMPLATE_DELETION_START,
  TEMPLATE_DELETED_SUCCESSFULLY,
  TEMPLATE_DELETION_FAILED,
} from '../actions/templateInfo';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: false,
  loading: false,
  template: {},
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    //Загрузка информации о шаблоне
    case TEMPLATE_INFO_LOADING_START:
      return {
        ...state,
        ready: false,
        loading: true,
        template: {},
      };
    case TEMPLATE_INFO_LOADED_SUCCESSFULLY:
      return {
        ...state,
        ready: true,
        loading: false,
        template: action.payload.template,
      };
    case TEMPLATE_INFO_LOADING_FAILED:
    case TEMPLATE_DELETION_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    //Изменение видимости шаблона визитки
    case TEMPLATE_VISIBILITY_CHANGED_SUCCESSFULLY:
      return update(state, {
        template: {
          is_enabled: {$set: action.payload.status},
        }
      });
    //Удаление шаблона
    case TEMPLATE_DELETION_START:
      return {
        ...state,
        ready: false,
        loading: true,
      };
    case TEMPLATE_DELETED_SUCCESSFULLY:
      return {
        ...state,
        ready: false,
        loading: false,
        template: {},
      };
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}